export const GOOGLE_SIGNIN_NOT_CONFIGURED_MESSAGE =
  'Google sign-in is not set up for this environment. Sign in with email and password, or contact support if you need Google login.';

export class GoogleSignInConfigError extends Error {
  override name = 'GoogleSignInConfigError';

  constructor(message = GOOGLE_SIGNIN_NOT_CONFIGURED_MESSAGE) {
    super(message);
  }
}

export function isGoogleSignInConfigError(error: Error): boolean {
  return error.name === 'GoogleSignInConfigError';
}
